var React = require('react');

function Grid (props) {
    return React.createElement("symbol",props,React.createElement("path",{"d":"M22 24h-7c-1.103 0-2-.897-2-2v-7c0-1.103.897-2 2-2h7c1.103 0 2 .897 2 2v7c0 1.103-.897 2-2 2zm-7-9v7h6.997L22 15h-7zm7-4h-7c-1.103 0-2-.897-2-2V2c0-1.103.897-2 2-2h7c1.103 0 2 .897 2 2v7c0 1.103-.897 2-2 2zm-7-9v7h6.997L22 2h-7zM9.002 24H2c-1.103 0-2-.897-2-2v-7c0-1.103.897-2 2-2h7.002c1.103 0 2 .897 2 2v7c0 1.103-.897 2-2 2zM2 15v7h6.999l.003-7H2zm7.002-4H2c-1.103 0-2-.897-2-2V2C0 .897.897 0 2 0h7.002c1.103 0 2 .897 2 2v7c0 1.103-.897 2-2 2zM2 2v7h6.999l.003-7H2z"}));
}

Grid.displayName = "Grid";

Grid.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 24 24"};

module.exports = Grid;

Grid.default = Grid;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/grid.svg
// module id = 1269
// module chunks = 0